'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { ReactNode } from 'react'

type DeprecatedTooltipProps = {
  content: ReactNode
  children: ReactNode
}

/**
 * @deprecated Legacy escape hatch for disabled controls and rich tooltip content.
 * Do not use for new code. Exists only to migrate off the old Floating UI Tooltip.
 */
export function DeprecatedTooltip({
  content,
  children,
}: DeprecatedTooltipProps) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content side="top" sideOffset={6} className="z-50">
          <div className="border-default bg-default text-high-emphasis typography-body-xs-normal relative flex max-w-[60ch] flex-col gap-0.5 rounded-sm border p-3 drop-shadow-sm">
            {content}
          </div>
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )
}
